/* ==========================================================================
   ZGN — tema davranışları
   Bağımlılık yok. Her modül kendi try/catch'i içinde çalışır; biri hata
   verirse diğerleri etkilenmez. Animasyonlar yalnızca bu dosya çalıştığında
   devreye girer (html.zgn-anim-ready), böylece içerik asla gizli kalmaz.
   ========================================================================== */
(function () {
  'use strict';

  var T = window.zgnTheme || {};
  var routes = T.routes || { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' };
  var strings = T.strings || {};
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function safe(name, fn) {
    try { fn(); } catch (e) { if (window.console) console.warn('[zgn] ' + name, e); }
  }
  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts || false); }
  function rootUrl(path) {
    var r = routes.root || '/';
    if (r.charAt(r.length - 1) !== '/') r += '/';
    return r + path.replace(/^\//, '');
  }

  /* ---------- Para biçimi ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    format = format || T.moneyFormat || '{{amount}}';
    function fmt(n, precision, thousands, decimal) {
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      var num = (n / 100).toFixed(precision);
      var parts = num.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': value = fmt(cents, 0, ' ', ''); break;
      case 'amount_with_space_separator': value = fmt(cents, 2, ' ', ','); break;
      case 'amount_with_period_and_space_separator': value = fmt(cents, 2, ' ', '.'); break;
      default: value = fmt(cents, 2);
    }
    var out = match ? format.replace(match[0], value) : value;
    var tmp = document.createElement('div');
    tmp.innerHTML = out;
    return tmp.textContent || out;
  }

  /* ---------- Giriş animasyonları ---------- */
  function initReveal(scope) {
    var sections = qsa('[data-anim]', scope);
    if (!sections.length) return;
    if (designMode || reduceMotion || !('IntersectionObserver' in window) || document.body.classList.contains('no-anim')) {
      sections.forEach(function (s) { s.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    sections.forEach(function (s) { io.observe(s); });
    // Güvenlik: her ihtimale karşı, görünür alandaki bölümleri kısa süre sonra aç
    setTimeout(function () {
      sections.forEach(function (s) {
        var r = s.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) s.classList.add('is-in');
      });
    }, 1500);
  }

  /* ---------- Üst menü ---------- */
  function initHeader() {
    var wrap = qs('[data-header]');
    if (!wrap) return;
    var ticking = false;
    function update() {
      wrap.classList.toggle('is-scrolled', window.scrollY > 10);
      ticking = false;
    }
    on(window, 'scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();

    // Açılır menüler: biri açılınca diğerleri kapansın, dışarı tıklayınca kapansın
    qsa('[data-dropdown]').forEach(function (d) {
      on(d, 'toggle', function () {
        if (d.open) qsa('[data-dropdown]').forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
    on(document, 'click', function (e) {
      qsa('[data-dropdown][open]').forEach(function (d) { if (!d.contains(e.target)) d.open = false; });
    });
  }

  /* ---------- Çekmeceler ---------- */
  var lastFocus = null;
  function openDrawer(drawer) {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('zgn-locked');
    qsa('[aria-controls="' + drawer.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var focusable = qs('button, a[href], input, select, textarea', drawer.querySelector('.zgn-drawer__panel'));
    if (focusable) setTimeout(function () { focusable.focus(); }, 60);
  }
  function closeDrawer(drawer) {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (!qs('.zgn-drawer.is-open')) document.documentElement.classList.remove('zgn-locked');
    qsa('[aria-controls="' + drawer.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function initDrawers() {
    on(document, 'click', function (e) {
      var opener = e.target.closest('[data-drawer-open]');
      if (opener) {
        e.preventDefault();
        openDrawer(document.getElementById(opener.getAttribute('data-drawer-open')));
        return;
      }
      var closer = e.target.closest('[data-drawer-close]');
      if (closer) {
        e.preventDefault();
        closeDrawer(closer.closest('[data-drawer]'));
      }
    });
    on(document, 'keydown', function (e) {
      if (e.key === 'Escape') qsa('.zgn-drawer.is-open').forEach(closeDrawer);
    });
  }

  /* ---------- Sepet ---------- */
  function cartDrawer() { return document.getElementById('zgn-cart-drawer'); }
  function useDrawer() { return T.cartType !== 'page' && !!cartDrawer(); }

  function updateCount(count) {
    qsa('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      if (count > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
    });
  }

  function renderDrawerFromSections(sections) {
    if (!sections || !sections['cart-drawer']) return false;
    var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
    var fresh = qs('[data-cart-drawer-inner]', doc);
    var current = qs('[data-cart-drawer-inner]');
    if (fresh && current) {
      current.innerHTML = fresh.innerHTML;
      document.dispatchEvent(new CustomEvent('cart:rendered'));
      return true;
    }
    return false;
  }

  function refreshCart() {
    return fetch(rootUrl('cart.js'), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCount(cart.item_count);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
        return fetch(rootUrl('?sections=cart-drawer'));
      })
      .then(function (r) { return r.json(); })
      .then(function (sections) { renderDrawerFromSections(sections); })
      .catch(function () {});
  }

  function showFormError(form, msg) {
    var box = form && (qs('[data-form-error]', form) || (form.closest('.zgn-pblock') && qs('[data-form-error]', form.closest('.zgn-pblock'))));
    if (box) { box.textContent = msg; box.hidden = false; }
    else if (msg) window.alert(msg);
  }

  function addToCart(form, button) {
    var data = new FormData(form);
    // form dışındaki (form="id" ile bağlı) alanlar FormData'ya zaten dahildir
    if (!data.get('quantity')) data.set('quantity', '1');
    data.append('sections', 'cart-drawer');
    data.append('sections_url', window.location.pathname);
    var label = button && qs('[data-add-text]', button);
    var oldText = label ? label.textContent : '';
    if (button) { button.classList.add('is-loading'); button.setAttribute('aria-busy', 'true'); if (label) label.textContent = strings.adding || '…'; }
    var errBox = qs('[data-form-error]', form);
    if (errBox) errBox.hidden = true;

    var responded = false;
    return fetch(rootUrl('cart/add.js'), {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: data
    })
      .then(function (r) { responded = true; return r.json().then(function (json) { return { ok: r.ok, json: json }; }); })
      .then(function (res) {
        if (!res.ok || res.json.status) {
          showFormError(form, res.json.description || res.json.message || strings.error);
          return;
        }
        var rendered = renderDrawerFromSections(res.json.sections);
        document.dispatchEvent(new CustomEvent('cart:item-added', { detail: { item: res.json } }));
        return fetch(rootUrl('cart.js'), { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            updateCount(cart.item_count);
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
            if (!rendered) return refreshCart();
          })
          .then(function () {
            if (qs('[data-cart-page]')) window.location.reload();
            else if (useDrawer()) openDrawer(cartDrawer());
            else window.location.href = routes.cart || '/cart';
          });
      })
      .catch(function () {
        if (!responded) {
          // Ağ hatası (istek hiç ulaşmadı): normal form gönderimine geri dön
          HTMLFormElement.prototype.submit.call(form);
        } else {
          // Ürün eklendi ama arayüz güncellenemedi: sepeti yeniden çiz
          refreshCart().then(function () { if (useDrawer()) openDrawer(cartDrawer()); });
        }
      })
      .then(function () {
        if (button) { button.classList.remove('is-loading'); button.removeAttribute('aria-busy'); if (label && oldText) label.textContent = oldText; }
      });
  }

  function initCart() {
    on(document, 'submit', function (e) {
      var form = e.target;
      if (!form || !form.matches) return;
      if (!form.matches('[data-product-form], [data-quick-add]')) return;
      if (!useDrawer() || !window.fetch || !window.FormData) return; // yerel gönderim
      e.preventDefault();
      var btn = e.submitter || qs('[type=submit][name=add], [type=submit]', form);
      if (btn && btn.disabled) return;
      addToCart(form, btn);
    });

    on(document, 'click', function (e) {
      var openBtn = e.target.closest('[data-cart-open]');
      if (openBtn && useDrawer()) {
        e.preventDefault();
        openDrawer(cartDrawer());
        return;
      }
      var change = e.target.closest('[data-line-change]');
      if (change) {
        e.preventDefault();
        var line = parseInt(change.getAttribute('data-line-change'), 10);
        var qty = Math.max(0, parseInt(change.getAttribute('data-qty'), 10) || 0);
        var item = change.closest('[data-line-item]');
        if (item) item.classList.add('is-loading');
        fetch(rootUrl('cart/change.js'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: line, quantity: qty, sections: ['cart-drawer'], sections_url: window.location.pathname })
        })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            if (qs('[data-cart-page]')) { window.location.reload(); return; }
            if (cart.status && cart.description) window.alert(cart.description);
            updateCount(cart.item_count || 0);
            if (!renderDrawerFromSections(cart.sections)) refreshCart();
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
          })
          .catch(function () { window.location.href = routes.cart || '/cart'; });
      }
    });
  }

  /* ---------- Ürün sayfası ---------- */
  function initProduct(root) {
    var product = qs('[data-product]', root) || (root && root.matches && root.matches('[data-product]') ? root : null);
    if (!product || product.dataset.ready) return;
    product.dataset.ready = '1';
    var formId = product.getAttribute('data-form-id');
    var form = formId ? document.getElementById(formId) : null;
    var idInput = form ? qs('[data-variant-id]', form) : null;
    var addBtn = form ? qs('[data-add-button]', form) : null;
    var picker = qs('[data-variant-picker]', product);
    var section = product.closest('section');
    var variants = [];
    if (picker) {
      var json = qs('[data-variants-json]', picker);
      try { variants = JSON.parse(json ? json.textContent : '[]'); } catch (err) { variants = []; }
    }

    function selectedOptions() {
      var opts = [];
      qsa('[data-option-index]', picker).forEach(function (el) {
        var i = parseInt(el.getAttribute('data-option-index'), 10);
        if (el.tagName === 'SELECT') opts[i] = el.value;
        else if (el.checked) opts[i] = el.value;
      });
      return opts;
    }
    function findVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < opts.length; j++) { if (opts[j] !== undefined && v.options[j] !== opts[j]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }
    function setButton(v) {
      var label = addBtn ? qs('[data-add-text]', addBtn) : null;
      var addLabel = addBtn ? (addBtn.getAttribute('data-add-label') || strings.addToCart) : strings.addToCart;
      var text, disabled;
      if (!v) { text = strings.unavailable; disabled = true; }
      else if (!v.available) { text = strings.soldOut; disabled = true; }
      else { text = addLabel; disabled = false; }
      if (addBtn) { addBtn.disabled = disabled; if (label) label.textContent = text; }
      var sticky = qs('[data-sticky-add]', section);
      if (sticky) sticky.disabled = disabled;
    }
    function setPrice(v) {
      if (!v) return;
      var now = qs('[data-price-now]', product);
      var was = qs('[data-price-was]', product);
      var badge = qs('[data-price-badge]', product);
      var wrap = qs('[data-price]', product);
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      if (now) now.textContent = formatMoney(v.price);
      if (was) { was.textContent = onSale ? formatMoney(v.compare_at_price) : ''; was.hidden = !onSale; }
      if (badge) { badge.hidden = !onSale; if (onSale) badge.textContent = '%' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price); }
      if (wrap) wrap.classList.toggle('is-sale', !!onSale);
      var sp = qs('[data-sticky-price]', section);
      if (sp) sp.textContent = formatMoney(v.price);
      var bp = form ? qs('[data-button-price]', form) : null;
      if (bp) bp.textContent = formatMoney(v.price);
    }
    // Fiyatlı kartlar: diğer seçenek değişince her kartın fiyatını güncelle
    function setCardPrices(opts) {
      qsa('[data-opt-card]', picker).forEach(function (card) {
        var i = parseInt(card.getAttribute('data-opt-card'), 10);
        var input = card.previousElementSibling;
        if (!input) return;
        var o = opts.slice(); o[i] = input.value;
        var v = findVariant(o);
        var price = qs('[data-opt-price]', card), was = qs('[data-opt-compare]', card), save = qs('[data-opt-save]', card);
        if (!v || !price) return;
        var onSale = v.compare_at_price && v.compare_at_price > v.price;
        price.textContent = formatMoney(v.price);
        if (was) { was.textContent = onSale ? formatMoney(v.compare_at_price) : ''; was.hidden = !onSale; }
        if (save) { save.hidden = !onSale; if (onSale) save.textContent = '%' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price); }
      });
    }
    function setMedia(v) {
      if (!v || !v.featured_media) return;
      var slide = qs('[data-media-id="' + v.featured_media.id + '"]', product);
      var track = qs('[data-gallery-track]', product);
      if (slide && track) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
    }
    function onChange() {
      var opts = selectedOptions();
      opts.forEach(function (val, i) {
        var lab = qs('[data-option-label="' + i + '"]', picker);
        if (lab) lab.textContent = val;
      });
      var v = findVariant(opts);
      if (v && idInput) {
        idInput.value = v.id;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      setButton(v);
      setPrice(v);
      setCardPrices(opts);
      setMedia(v);
      if (v && window.history && window.history.replaceState && !designMode) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      product.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { variant: v } }));
    }
    if (picker) {
      on(picker, 'change', onChange);
      // tükenen kombinasyonları işaretle
      qsa('.zgn-pills__input', picker).forEach(function (input) {
        var i = parseInt(input.getAttribute('data-option-index'), 10);
        var any = variants.some(function (v) { return v.options[i] === input.value && v.available; });
        var pill = input.nextElementSibling;
        if (pill && !any) pill.classList.add('is-unavailable');
      });
    }

    // Adet
    qsa('[data-qty]', product).forEach(function (box) {
      var input = qs('input', box);
      on(box, 'click', function (e) {
        var b = e.target.closest('[data-qty-step]');
        if (!b || !input) return;
        var next = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-qty-step'), 10));
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    // Hediye notu
    qsa('[data-gift]', product).forEach(function (g) {
      var toggle = qs('[data-gift-toggle]', g);
      var note = qs('[data-gift-note]', g);
      var area = note ? qs('textarea', note) : null;
      on(toggle, 'change', function () {
        if (note) note.hidden = !toggle.checked;
        if (area) area.disabled = !toggle.checked;
      });
    });

    // Galeri
    var track = qs('[data-gallery-track]', product);
    if (track) {
      var slides = qsa('.zgn-gallery__slide', track);
      var thumbs = qsa('[data-gallery-thumb]', product);
      function go(i) {
        i = Math.max(0, Math.min(slides.length - 1, i));
        var s = slides[i];
        if (s) track.scrollTo({ left: s.offsetLeft - track.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
      }
      function current() { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); }
      on(qs('[data-gallery-prev]', product), 'click', function () { go(current() - 1); });
      on(qs('[data-gallery-next]', product), 'click', function () { go(current() + 1); });
      thumbs.forEach(function (t) { on(t, 'click', function () { go(parseInt(t.getAttribute('data-gallery-thumb'), 10)); }); });
      var raf = null;
      on(track, 'scroll', function () {
        if (raf) return;
        raf = window.requestAnimationFrame(function () {
          raf = null;
          var c = current();
          thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === c); });
          slides.forEach(function (s, i) {
            var vid = qs('video', s);
            if (vid && i !== c && !vid.paused) vid.pause();
          });
        });
      }, { passive: true });
    }

    // Kargo saati
    qsa('[data-ship-timer]', product).forEach(initShipTimer);

    // Stok uyarısı: varyant değişince gerçek stok sayısını göster
    var stock = qs('[data-stock]', product);
    if (stock) {
      var stockMap = {};
      try { stockMap = JSON.parse((qs('[data-stock-json]', stock) || {}).textContent || '{}'); } catch (err) { stockMap = {}; }
      on(product, 'variant:change', function (e) {
        var v = e.detail && e.detail.variant;
        var q = v ? stockMap[v.id] : null;
        var limit = parseInt(stock.getAttribute('data-threshold'), 10) || 10;
        var showIn = stock.getAttribute('data-show-in') === 'true';
        var low = q !== null && q !== undefined && q > 0 && q <= limit;
        var show = q !== null && q !== undefined && q > 0 && (low || showIn);
        stock.hidden = !show;
        stock.classList.toggle('is-low', low);
        var t = qs('[data-stock-text]', stock);
        if (t && show) t.textContent = low ? (stock.getAttribute('data-low-text') || '').replace(/\[adet\]/g, q) : stock.getAttribute('data-in-text');
      });
    }

    // Adet paketleri: buton fiyatını seçilen adede göre güncelle
    var bundles = qs('[data-bundles]', product);
    if (bundles) {
      var unit = parseInt(bundles.getAttribute('data-unit-price'), 10) || 0;
      on(bundles, 'change', function (e) {
        if (!e.target.matches('[data-bundle-qty]')) return;
        var n = parseInt(e.target.value, 10) || 1;
        var bp = form ? qs('[data-button-price]', form) : null;
        if (bp) bp.textContent = formatMoney(unit * n);
      });
    }

    // Kayan sepet çubuğu
    var sticky = qs('[data-sticky-buy]', section);
    if (sticky && form && 'IntersectionObserver' in window) {
      var footer = qs('.zgn-footer');
      var formVisible = true, footerVisible = false;
      function sync() {
        var show = !formVisible && !footerVisible;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        var b = qs('[data-sticky-add]', sticky);
        if (b) b.tabIndex = show ? 0 : -1;
      }
      new IntersectionObserver(function (en) { formVisible = en[0].isIntersecting || en[0].boundingClientRect.top > 0; sync(); }).observe(form);
      if (footer) new IntersectionObserver(function (en) { footerVisible = en[0].isIntersecting; sync(); }).observe(footer);
      on(qs('[data-sticky-add]', sticky), 'click', function () {
        if (addBtn && !addBtn.disabled) {
          if (form.requestSubmit) form.requestSubmit(addBtn); else addBtn.click();
        } else {
          form.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
        }
      });
    }
  }

  function istanbulNow() {
    // Türkiye saatine göre şu anki zamanın bileşenleri
    try {
      var parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Istanbul', weekday: 'short', hour: '2-digit', minute: '2-digit', hour12: false }).formatToParts(new Date());
      var o = {};
      parts.forEach(function (p) { o[p.type] = p.value; });
      var days = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
      return { day: days[o.weekday], h: parseInt(o.hour, 10) % 24, m: parseInt(o.minute, 10) };
    } catch (e) {
      var d = new Date();
      return { day: d.getDay(), h: d.getHours(), m: d.getMinutes() };
    }
  }

  function initShipTimer(el) {
    var before = qs('[data-ship-before]', el);
    var after = qs('[data-ship-after]', el);
    if (!before || !after) return;
    var tpl = before.getAttribute('data-tpl') || before.innerHTML;
    before.setAttribute('data-tpl', tpl);
    var cutoff = (el.getAttribute('data-cutoff') || '16:00').split(':');
    var ch = parseInt(cutoff[0], 10), cm = parseInt(cutoff[1], 10) || 0;
    if (isNaN(ch)) ch = 16;
    var saturday = el.getAttribute('data-saturday') === 'true';
    function tick() {
      var n = istanbulNow();
      var shipDay = (n.day >= 1 && n.day <= 5) || (saturday && n.day === 6);
      var left = (ch * 60 + cm) - (n.h * 60 + n.m);
      if (shipDay && left > 0) {
        var h = Math.floor(left / 60), m = left % 60;
        var uh = el.getAttribute('data-unit-h') || 'h', um = el.getAttribute('data-unit-m') || 'min';
        var txt = (h > 0 ? h + ' ' + uh + ' ' : '') + m + ' ' + um;
        before.innerHTML = tpl.replace(/\[sure\]/g, txt);
        before.hidden = false; after.hidden = true;
      } else {
        before.hidden = true; after.hidden = false;
      }
    }
    tick();
    setInterval(tick, 30000);
  }

  /* ---------- Sekmeler ---------- */
  function initTabs(scope) {
    qsa('[data-tabs]', scope).forEach(function (wrap) {
      if (wrap.dataset.ready) return;
      wrap.dataset.ready = '1';
      var tabs = qsa('[data-tab]', wrap);
      function select(tab, focus) {
        tabs.forEach(function (t) {
          var on_ = t === tab;
          t.setAttribute('aria-selected', on_ ? 'true' : 'false');
          t.tabIndex = on_ ? 0 : -1;
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) {
            panel.hidden = !on_;
            if (on_) { panel.classList.remove('is-entering'); void panel.offsetWidth; panel.classList.add('is-entering'); }
          }
        });
        if (focus) tab.focus();
      }
      tabs.forEach(function (t, i) {
        on(t, 'click', function () { select(t); });
        on(t, 'keydown', function (e) {
          if (e.key === 'ArrowRight') { e.preventDefault(); select(tabs[(i + 1) % tabs.length], true); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); select(tabs[(i - 1 + tabs.length) % tabs.length], true); }
        });
      });
      wrap.zgnSelect = function (blockEl) { if (blockEl) select(blockEl); };
    });
  }

  /* ---------- Yatay kaydırıcılar ---------- */
  function initScrollers() {
    on(document, 'click', function (e) {
      var btn = e.target.closest('[data-scroll-prev], [data-scroll-next]');
      if (!btn) return;
      var sec = btn.closest('section') || document;
      var scroller = qs('[data-scroller]', sec);
      if (!scroller) return;
      var dir = btn.hasAttribute('data-scroll-next') ? 1 : -1;
      scroller.scrollBy({ left: dir * scroller.clientWidth * 0.8, behavior: reduceMotion ? 'auto' : 'smooth' });
    });
  }

  /* ---------- Video slider ---------- */
  function initVideoRails(scope) {
    qsa('[data-video-rail]', scope).forEach(function (rail) {
      if (rail.dataset.ready) return;
      rail.dataset.ready = '1';
      var autoplay = rail.getAttribute('data-autoplay') === 'true' && !reduceMotion;
      var cards = qsa('.zgn-vcard', rail);
      if (autoplay && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            var v = qs('video', en.target);
            if (!v) return;
            if (en.isIntersecting && en.intersectionRatio > 0.6) {
              v.muted = true;
              var p = v.play();
              if (p && p.catch) p.catch(function () {});
              en.target.classList.add('is-playing');
            } else {
              v.pause();
              en.target.classList.remove('is-playing');
            }
          });
        }, { threshold: [0, 0.6, 1] });
        cards.forEach(function (c) { io.observe(c); });
      }
      var section = rail.closest('section');
      var modal = section ? qs('[data-video-modal]', section) : null;
      var body = modal ? qs('[data-video-modal-body]', modal) : null;
      rail.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-video-open]');
        if (!btn) return;
        var src = qs('video', btn);
        if (!modal || !body || !src) return;
        var source = src.currentSrc || src.getAttribute('src') || (qs('source', src) && qs('source', src).getAttribute('src'));
        if (!source) return;
        var v = document.createElement('video');
        v.src = source;
        v.controls = true;
        v.playsInline = true;
        v.setAttribute('playsinline', '');
        v.autoplay = true;
        body.innerHTML = '';
        body.appendChild(v);
        openDialog(modal);
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      });
      if (modal) on(modal, 'close', function () { if (body) body.innerHTML = ''; });
    });
  }

  /* ---------- Dialoglar ---------- */
  function openDialog(d) {
    if (!d) return;
    if (typeof d.showModal === 'function') { if (!d.open) d.showModal(); }
    else d.setAttribute('open', '');
  }
  function closeDialog(d) {
    if (!d) return;
    if (typeof d.close === 'function') d.close();
    else { d.removeAttribute('open'); d.dispatchEvent(new Event('close')); }
  }
  function initDialogs() {
    on(document, 'click', function (e) {
      var opener = e.target.closest('[data-dialog-open]');
      if (opener) { e.preventDefault(); openDialog(document.getElementById(opener.getAttribute('data-dialog-open'))); return; }
      var closer = e.target.closest('[data-dialog-close]');
      if (closer) { e.preventDefault(); closeDialog(closer.closest('dialog')); return; }
      if (e.target.tagName === 'DIALOG' && e.target.open) closeDialog(e.target); // arka plana tıklama
    });
  }

  /* ---------- Görsel slider ---------- */
  function initSliders(scope) {
    qsa('[data-slider]', scope).forEach(function (box) {
      if (box.dataset.ready) return;
      box.dataset.ready = '1';
      var slides = qsa('[data-slide]', box);
      var bars = qsa('[data-slide-to]', box);
      if (slides.length < 2) return;
      var idx = 0, timer = null;
      var interval = Math.max(3, parseInt(box.getAttribute('data-interval'), 10) || 6) * 1000;
      var autoplay = box.getAttribute('data-autoplay') === 'true' && !reduceMotion;
      box.style.setProperty('--interval', (interval / 1000) + 's');
      function show(i) {
        idx = (i + slides.length) % slides.length;
        slides.forEach(function (s, n) {
          var active = n === idx;
          s.classList.toggle('is-active', active);
          s.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        bars.forEach(function (b, n) {
          b.classList.remove('is-active');
          b.classList.toggle('is-done', n < idx);
          if (n === idx) { void b.offsetWidth; b.classList.add('is-active'); }
        });
        restart();
      }
      function restart() {
        if (timer) clearTimeout(timer);
        if (autoplay && !designMode) timer = setTimeout(function () { show(idx + 1); }, interval);
      }
      on(qs('[data-slide-prev]', box), 'click', function () { show(idx - 1); });
      on(qs('[data-slide-next]', box), 'click', function () { show(idx + 1); });
      bars.forEach(function (b) { on(b, 'click', function () { show(parseInt(b.getAttribute('data-slide-to'), 10)); }); });
      on(box, 'mouseenter', function () { if (timer) clearTimeout(timer); });
      on(box, 'mouseleave', restart);
      // dokunmatik kaydırma
      var sx = null;
      on(box, 'touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      on(box, 'touchend', function (e) {
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 40) show(idx + (dx < 0 ? 1 : -1));
        sx = null;
      });
      box.zgnShow = function (el) { var n = slides.indexOf(el); if (n >= 0) show(n); };
      show(0);
    });
  }

  /* ---------- Video giriş ---------- */
  function initVideoHero(scope) {
    qsa('[data-video-hero]', scope).forEach(function (box) {
      var btn = qs('[data-video-toggle]', box);
      if (!btn || btn.dataset.ready) return;
      btn.dataset.ready = '1';
      on(btn, 'click', function () {
        var vids = qsa('video', box).filter(function (v) { return v.offsetParent !== null; });
        if (!vids.length) return;
        var paused = vids[0].paused;
        vids.forEach(function (v) { if (paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause(); });
        btn.setAttribute('aria-label', paused ? btn.getAttribute('data-label-pause') : btn.getAttribute('data-label-play'));
        btn.classList.toggle('is-paused', !paused);
      });
      if (reduceMotion) qsa('video', box).forEach(function (v) { v.pause(); });
    });
  }

  /* ---------- Önce / sonra ---------- */
  function initBeforeAfter(scope) {
    qsa('[data-before-after]', scope).forEach(function (box) {
      var range = qs('[data-before-after-range]', box);
      if (!range || range.dataset.ready) return;
      range.dataset.ready = '1';
      function set() { box.style.setProperty('--pos', range.value + '%'); }
      on(range, 'input', set);
      set();
    });
  }

  /* ---------- Ürün noktaları ---------- */
  function initHotspots() {
    on(document, 'click', function (e) {
      var btn = e.target.closest('[data-spot-toggle]');
      qsa('[data-spot-toggle][aria-expanded=true]').forEach(function (b) {
        if (b !== btn && !(e.target.closest('.zgn-spot') === b.closest('.zgn-spot'))) {
          b.setAttribute('aria-expanded', 'false');
          var c = document.getElementById(b.getAttribute('aria-controls'));
          if (c) c.hidden = true;
        }
      });
      if (!btn) return;
      var card = document.getElementById(btn.getAttribute('aria-controls'));
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (card) card.hidden = open;
    });
  }

  /* ---------- Geri sayım ---------- */
  function initCountdowns(scope) {
    qsa('[data-countdown]', scope).forEach(function (box) {
      if (box.dataset.ready) return;
      box.dataset.ready = '1';
      var raw = (box.getAttribute('data-end') || '').trim();
      if (!raw) return;
      var m = raw.match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2}))?$/);
      if (!m) return;
      var iso = m[1] + '-' + ('0' + m[2]).slice(-2) + '-' + ('0' + m[3]).slice(-2) + 'T' + ('0' + (m[4] || '23')).slice(-2) + ':' + (m[5] || '59') + ':00+03:00';
      var end = Date.parse(iso);
      if (isNaN(end)) return;
      var hide = box.getAttribute('data-hide') === 'true';
      var els = { d: qs('[data-cd=d]', box), h: qs('[data-cd=h]', box), m: qs('[data-cd=m]', box), s: qs('[data-cd=s]', box) };
      var ended = qs('[data-cd-ended]', box);
      var timer = null;
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function tick() {
        var left = Math.max(0, Math.floor((end - Date.now()) / 1000));
        var d = Math.floor(left / 86400); left -= d * 86400;
        var h = Math.floor(left / 3600); left -= h * 3600;
        var mi = Math.floor(left / 60); var s = left - mi * 60;
        if (els.d) els.d.textContent = pad(d);
        if (els.h) els.h.textContent = pad(h);
        if (els.m) els.m.textContent = pad(mi);
        if (els.s) els.s.textContent = pad(s);
        if (end - Date.now() <= 0) {
          clearInterval(timer);
          if (hide && !designMode) { var sec = box.closest('section'); if (sec) sec.hidden = true; }
          else if (ended) ended.hidden = false;
        }
      }
      tick();
      timer = setInterval(tick, 1000);
    });
  }

  /* ---------- Filtreler ---------- */
  function initFacets() {
    on(document, 'click', function (e) {
      var t = e.target.closest('[data-facets-toggle]');
      if (!t) return;
      var panel = document.getElementById(t.getAttribute('aria-controls'));
      if (!panel) return;
      var open = !panel.hidden;
      panel.hidden = open;
      t.setAttribute('aria-expanded', open ? 'false' : 'true');
    });
    on(document, 'change', function (e) {
      if (e.target.matches && e.target.matches('[data-sort-select]')) {
        var f = e.target.form;
        if (f) {
          qsa('input[type=number]', f).forEach(function (i) { if (i.value === '') i.disabled = true; });
          f.submit();
        }
      }
    });
    // Boş fiyat alanlarını göndermeyelim
    on(document, 'submit', function (e) {
      if (!e.target.matches || !e.target.matches('[data-facets-form]')) return;
      qsa('input[type=number]', e.target).forEach(function (i) { if (i.value === '') i.disabled = true; });
    });
  }

  /* ---------- Önerilen ürünler ---------- */
  function initRecommendations(scope) {
    qsa('[data-recommendations]', scope).forEach(function (box) {
      if (box.dataset.ready || box.children.length) return;
      box.dataset.ready = '1';
      var url = box.getAttribute('data-url');
      if (!url || !window.fetch) return;
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = qs('[data-recommendations]', doc);
        if (fresh && fresh.innerHTML.trim()) {
          box.innerHTML = fresh.innerHTML;
          var sec = box.closest('[data-anim]');
          if (sec) sec.classList.add('is-in');
        } else {
          var s = box.closest('section');
          if (s && !designMode) s.hidden = true;
        }
      }).catch(function () {});
    });
  }

  /* ---------- Duyuru: tek tek değişen ---------- */
  function initAnnounceRotate(scope) {
    qsa('[data-announce-rotate]', scope).forEach(function (box) {
      if (box.dataset.ready) return;
      box.dataset.ready = '1';
      var items = qsa('[data-rotate-item]', box);
      if (items.length < 2) return;
      var i = 0, ms = Math.max(3, parseInt(box.getAttribute('data-interval'), 10) || 4) * 1000, timer = null;
      function show(n) { i = (n + items.length) % items.length; items.forEach(function (el, k) { el.classList.toggle('is-active', k === i); }); }
      function start() { stop(); timer = setInterval(function () { show(i + 1); }, ms); }
      function stop() { if (timer) clearInterval(timer); timer = null; }
      on(box, 'mouseenter', stop);
      on(box, 'mouseleave', start);
      on(box, 'focusin', stop);
      on(box, 'focusout', start);
      box._zgnShow = function (el) { var n = items.indexOf(el); if (n >= 0) { show(n); stop(); } };
      start();
    });
  }

  /* ---------- Anında arama ---------- */
  function initPredictiveSearch() {
    var box = qs('[data-predictive-search]');
    if (!box || !window.fetch) return;
    var input = qs('[data-ps-input]', box);
    var results = qs('[data-ps-box]', box);
    var url = routes.predictiveSearch || rootUrl('search/suggest');
    var timer = null, ctrl = null;
    function run() {
      var q = input.value.trim();
      if (ctrl) ctrl.abort();
      if (q.length < 2) { results.innerHTML = ''; return; }
      ctrl = window.AbortController ? new AbortController() : null;
      results.classList.add('is-loading');
      var params = 'q=' + encodeURIComponent(q) + '&section_id=predictive-search&resources%5Btype%5D=product,collection,page,query&resources%5Blimit%5D=6&resources%5Boptions%5D%5Bunavailable_products%5D=last';
      fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + params, ctrl ? { signal: ctrl.signal } : {})
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = qs('[data-ps-results]', doc);
          results.innerHTML = fresh ? fresh.innerHTML : '';
          results.classList.remove('is-loading');
        })
        .catch(function (err) { if (!err || err.name !== 'AbortError') results.classList.remove('is-loading'); });
    }
    on(input, 'input', function () { clearTimeout(timer); timer = setTimeout(run, 220); });
  }

  /* ---------- Formlar ---------- */
  function initForms() {
    qsa('select[data-default]').forEach(function (s) {
      var v = s.getAttribute('data-default');
      if (v) { for (var i = 0; i < s.options.length; i++) { if (s.options[i].value === v || s.options[i].text === v) { s.selectedIndex = i; break; } } }
    });
  }

  /* ---------- Başlat ---------- */
  function initScope(scope) {
    safe('reveal', function () { initReveal(scope); });
    safe('product', function () { initProduct(scope); });
    safe('tabs', function () { initTabs(scope); });
    safe('video rails', function () { initVideoRails(scope); });
    safe('sliders', function () { initSliders(scope); });
    safe('video hero', function () { initVideoHero(scope); });
    safe('before after', function () { initBeforeAfter(scope); });
    safe('countdown', function () { initCountdowns(scope); });
    safe('announce', function () { initAnnounceRotate(scope); });
    safe('recommendations', function () { initRecommendations(scope); });
  }

  function boot() {
    safe('anim flag', function () { document.documentElement.classList.add('zgn-anim-ready'); });
    safe('header', initHeader);
    safe('drawers', initDrawers);
    safe('cart', initCart);
    safe('scrollers', initScrollers);
    safe('dialogs', initDialogs);
    safe('hotspots', initHotspots);
    safe('facets', initFacets);
    safe('predictive search', initPredictiveSearch);
    safe('forms', initForms);
    initScope(document);

    // Tema düzenleyicisi desteği
    on(document, 'shopify:section:load', function (e) { initScope(e.target); });
    on(document, 'shopify:block:select', function (e) {
      safe('block select', function () {
        var el = e.target;
        var tabs = el.closest('[data-tabs]');
        if (tabs && tabs.zgnSelect && el.hasAttribute('data-tab')) tabs.zgnSelect(el);
        var rot = el.closest('[data-announce-rotate]');
        if (rot && rot._zgnShow) rot._zgnShow(el);
        var slider = el.closest('[data-slider]');
        if (slider && slider.zgnShow && el.hasAttribute('data-slide')) slider.zgnShow(el);
        var sec = el.closest('[data-anim]');
        if (sec) sec.classList.add('is-in');
      });
    });
    on(document, 'shopify:section:select', function (e) {
      var sec = qs('[data-anim]', e.target) || (e.target.matches && e.target.matches('[data-anim]') ? e.target : null);
      if (sec) sec.classList.add('is-in');
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  window.zgnTheme = window.zgnTheme || {};
  window.zgnTheme.formatMoney = formatMoney;
  window.zgnTheme.refreshCart = refreshCart;
  window.zgnTheme.openCart = function () { openDrawer(cartDrawer()); };
})();
